export enum WorkflowValidationStatus {
    INITIALIZING = 'INITIALIZING',
    RUNNING = 'RUNNING',
    SUCCEEDED = 'SUCCEEDED',
    FAILED = 'FAILED'
}
